/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 *
 */
import styled from 'styled-components';

const WIDTH = 32;
export const INITIAL_ICON_CLASS = 'firstIconShown';
export const INITIAL_ICON_ACTIVE_CLASS = 'firstIconShown--active';
export const ALTERNATE_ICON_CLASS = 'alternateIconShown';
export const ALTERNATE_ICON_ACTIVE_CLASS = 'alternateIconShown--active';

interface StyledControlWrapperProps {
  backgroundColor: string;
  height: string;
  marginTop: string;
}

const StyledControlWrapper = styled.div`
  margin-right: 8px;
  background-color: ${(props: StyledControlWrapperProps) => props.backgroundColor};
  width: ${WIDTH}px;
  height: ${(props: StyledControlWrapperProps) => props.height}px;
  margin-top: ${(props: StyledControlWrapperProps) => (props.marginTop ? props.marginTop : 0)}px;
  cursor: pointer;
  text-align: center;

  @media print {
    display: none;
  }

  .${ALTERNATE_ICON_ACTIVE_CLASS} {
    .${INITIAL_ICON_CLASS} {
      display: none !important;
    }

    .${ALTERNATE_ICON_CLASS} {
      display: inline-block !important;
    }
  }

  .${INITIAL_ICON_ACTIVE_CLASS} {
    .${ALTERNATE_ICON_CLASS} {
      display: none !important;
    }

    .${INITIAL_ICON_CLASS} {
      display: inline-block !important;
    }
  }
`;

export default StyledControlWrapper;
